<script>
// @flow

import { logger } from '../../logger'

export default {
  data () {
    return {
      hasFeatureFlags: false
    }
  },
  computed: {
    featureName (): string {
      return this.$attrs.name
    },
    variantGroups (): Array<string> {
      if (this.$attrs['variant-groups']) return this.$attrs['variant-groups']
      return ['test']
    },
    isEnabled (): boolean {
      return this.hasFeatureFlags && this.$isFeatureEnabled(this.featureName, this.variantGroups)
    }
  },
  created () {
    if (this.$posthog) {
      this.hasFeatureFlags = Object.keys(this.$posthog.featureFlags.getFlagVariants()).length > 0
      this.$posthog.onFeatureFlags(() => {
        this.hasFeatureFlags = true
      })
    }
  },
  render () {
    logger.info(`Feature Flag ${this.featureName} is set ${this.isEnabled}.`)
    if (!this.isEnabled) return
    return this.$slots.default
  }
}
</script>
